<mat-form-field class="example-chip-list" appearance="outline">
  <mat-label>{{ property?.description }}</mat-label>
  <mat-chip-list #chipList aria-label="Fruit selection">
    <mat-chip
      *ngFor="let property of properties"
      [selectable]="selectable"
      [removable]="removable"
      (removed)="remove(property)"
    >
      {{ property }}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip>
    <input
      placeholder="Новое значение..."
      #propertyInput
      [formControl]="propertyCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let property of filteredProperties" [value]="property">
      {{ property }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
